<template>
    <div>
        <v-row>
            <v-text-field 
                v-model="searchName" 
                placeholder="all" 
                label="Name" 
                outlined 
                dense 
                v-on:keyup.enter="search">
            </v-text-field>
            <v-select
                v-model="searchType"
                :items="types"
                label="Type"
                dense
                outlined
                clearable
            ></v-select>
          
            <v-btn v-on:click="search">Search</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-on:click="collapseAll">Collapse All</v-btn>
        </v-row>
        <v-row>
            
        </v-row>

        <v-data-table
            :headers="magicItemHeaders"
            :items="magicItemsArray"
            :expanded.sync="expanded"
            item-key="name"
            show-expand
            class="elevation-1"

            :items-per-page="-1"
            hide-default-footer

        >
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <div class="item-contents">
                        <v-row>
                            <v-col>
                                <span class="detail-header">Description</span>
                                <br>
                                {{descriptionString(item)}}
                            </v-col>
                        </v-row>
                    </div>
                </td>
            </template>
        </v-data-table>
    </div>
</template>


<script>
export default {
    props:["magicItems"],

    data () {
        return {
            searchName: "",
            searchType:"",

            expanded: [],
            singleExpand: false,
            magicItemHeaders: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                { text: 'Type', value: 'equipment_category.name' },
            ],
            magicItemsArray: [],

            types: [
                "ammunition",
                "armor",
                "wondrous item",
                "weapon",
                "potion",
                "staff",
                "ring",
                "wand",
                "scroll",
                "rod"
            ],
        }
    },

    methods: {
        descriptionString(item) {
            let descString = "";
            item.desc.forEach(element => {
                descString += element + "\n"
            });
            return descString;
        },
        collapseAll() {
            this.expanded = [];
        },

        search() {
            this.magicItemsArray = this.magicItems.filter(this.searchFilter);
        },

        searchFilter(magicItem) {
            let isResult = true;
            if(this.searchName.length > 0 && isResult)
            {
                isResult = magicItem.name.toLowerCase().includes(this.searchName.toLowerCase());
            }
            if(this.searchType.length > 0 && isResult)
            {
                isResult = magicItem.equipment_category.name.toLowerCase() == this.searchType;
            }
            return isResult;
        },

    },
    beforeMount: function() {
        this.magicItemsArray = this.magicItems;
    },
    watch: {
        searchType(newVal) {
            if(newVal == null)
            {
                this.searchType = "";
            }
        },
    },
}
</script>


<style scoped>
.v-text-field, .v-btn, .v-select, .v-checkbox {
    margin: 10px !important;
    max-width: 200px !important;
}
.item-contents {
    margin: 15px !important;
}
.spell-type-area {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
}
.detail-header {
    font-weight: bold;
}
</style>
